import React, { useState, useRef, useEffect } from 'react';

const SearchableDropdown = ({ options, value, onChange, placeholder = 'Select...', labelKey = 'label', valueKey = 'value' }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const filtered = options.filter(o =>
    (o[labelKey] || '').toLowerCase().includes(search.toLowerCase())
  );

  const selected = options.find(o => o[valueKey] === value);

  return (
    <div ref={ref} style={{ position: 'relative', minWidth: 200 }}>
      <div
        onClick={() => setOpen(!open)}
        style={{
          border: '1px solid #ccc', borderRadius: 4, padding: '6px 10px',
          background: '#fff', cursor: 'pointer', fontSize: 14
        }}
      >
        {selected ? selected[labelKey] : placeholder}
      </div>
      {open && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0,
          background: '#fff', border: '1px solid #ccc', borderRadius: 4,
          zIndex: 1000, maxHeight: 250, overflow: 'auto', boxShadow: '0 4px 12px rgba(0,0,0,.15)'
        }}>
          <input
            type="text"
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Search..."
            autoFocus
            style={{
              width: '100%', border: 'none', borderBottom: '1px solid #eee',
              padding: '8px 10px', fontSize: 13, outline: 'none', boxSizing: 'border-box'
            }}
          />
          {filtered.map(o => (
            <div
              key={o[valueKey]}
              onClick={() => { onChange(o[valueKey]); setOpen(false); setSearch(''); }}
              style={{
                padding: '6px 10px', cursor: 'pointer', fontSize: 13,
                background: o[valueKey] === value ? '#e3f2fd' : '#fff'
              }}
              onMouseEnter={e => e.target.style.background = '#f5f5f5'}
              onMouseLeave={e => e.target.style.background = o[valueKey] === value ? '#e3f2fd' : '#fff'}
            >
              {o[labelKey]}
            </div>
          ))}
          {filtered.length === 0 && (
            <div style={{ padding: '8px 10px', color: '#999', fontSize: 13 }}>No results</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchableDropdown;
